var _path, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83971 12.3973C10.4854 12.1347 11.1038 12.0033 11.6947 12.0033C12.2857 12.0033 12.8986 12.1347 13.5334 12.3973C14.1791 12.6491 14.5019 12.9828 14.5019 13.3987V14.1046H8.88757V13.3987C8.88757 12.9828 9.20495 12.6491 9.83971 12.3973ZM12.6797 10.887C12.4061 11.1606 12.0778 11.2974 11.6947 11.2974C11.3117 11.2974 10.9834 11.1606 10.7098 10.887C10.4362 10.6134 10.2994 10.2851 10.2994 9.90207C10.2994 9.51902 10.4362 9.1907 10.7098 8.9171C10.9834 8.63255 11.3117 8.49027 11.6947 8.49027C12.0778 8.49027 12.4061 8.63255 12.6797 8.9171C12.9533 9.1907 13.0901 9.51902 13.0901 9.90207C13.0901 10.2851 12.9533 10.6134 12.6797 10.887Z",
    fill: "#006BD7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.838494,
    y: 0.643181,
    width: 21.7132,
    height: 21.7132,
    rx: 10.8566,
    stroke: "#006BD7",
    strokeWidth: 0.700425
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/PersonIcon.9effd847fc8bcd991720711a72e48903.svg";
export { ForwardRef as ReactComponent };